<!--

사천시(gnsc) 프로젝트에서 사용하는 팀명 검색 컴포넌트

부서명 검색 컴포넌트(SearchSelectCompanyName.vue) 오른쪽에 붙여서 사용한다.
options.department 로 전달된 부서명(회사 트리 상의 "과" 업체명)을 기준으로,
회사 트리에서 해당 부서의 직속 하위 업체(팀)만 선택지로 보여준다.

- 부서명이 선택되지 않은 경우("전체") 팀명 선택은 비활성화되고 "전체"만 표시된다.
- 부서명이 바뀌면 팀명은 "전체"("")로 초기화된다.
- 회사 트리는 로그인 사용자의 하위 트리만 반환되므로 all: true 로 전체 트리를 조회한다.

-->
<template>
  <div class="search-base search-container">
    <search-label-body :label="label" :label-hidden="!label" :columns="gridTemplateColumns">
      <div>
        <vs-select
          class="w-full xl:w-48"
          :disabled="readonly || !department"
          v-model="teamName"
          @change="onChange"
          not-data="검색 결과가 없습니다"
        >
          <vs-select-item v-for="(team, index) in teamList" :key="index" :text="team.text" :value="team.value" />
        </vs-select>
      </div>
    </search-label-body>
  </div>
</template>

<script>
import SearchLabelBody from "@/views/list/components/base/SearchLabelBody.vue";

export default {
  name: "SearchSelectTeamName",
  components: {
    SearchLabelBody,
  },
  props: {
    label: {
      default: "팀명",
      type: String,
    },
    value: [String, Number],
    readonly: Boolean,
    query: {
      type: Object,
      default: () => {
        return {
          tName: "",
        };
      },
    },
    // options.department : 현재 선택된 부서명 (없으면 팀 선택 불가)
    options: Object,
  },
  watch: {
    value(value) {
      this.teamName = value || "";
    },
    department() {
      // 부서가 바뀌면 이전 부서의 팀명은 의미가 없으므로 "전체" 로 초기화
      if (this.teamName !== "") {
        this.teamName = "";
        this.change("");
      }
    },
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    department() {
      return this.options && this.options["department"] ? this.options["department"] : "";
    },
    gridTemplateColumns() {
      return this.options && this.options["gridTemplateColumns"];
    },
    initData() {
      const defaultValue = this.options && this.options["default"] ? this.options["default"] : "";
      const _query_keys = Object.keys(this.query);
      const query = this.$route.query;
      const teamName = query[_query_keys[0]];
      return {
        teamName: teamName || defaultValue,
      };
    },
    teamList() {
      const resultList = [
        {
          value: "",
          text: "전체",
        },
      ];

      if (!this.department || !Array.isArray(this.companyTree) || this.companyTree.length === 0) {
        return resultList;
      }

      // 같은 이름의 부서가 트리에 여러 개 있을 수 있으므로 모두 찾아 하위 팀을 합친다.
      const departmentNodes = this.companyTree.filter(
        (item) => item.descendant && item.descendant.com_name === this.department
      );
      if (departmentNodes.length === 0) return resultList;

      const seen = new Set();
      departmentNodes.forEach((dept) => {
        const deptId = `${dept.descendant_id}`;
        this.companyTree
          .filter((item) => {
            if (!item.descendant || `${item.descendant_id}` === deptId) return false;
            // 부서의 직속 하위(팀)만: depth 가 1 크고, company_path 에 부서 id 가 포함된 업체
            if (item.depth !== dept.depth + 1) return false;
            const pathIds = `${item.company_path || ""}`.split("/").filter((p) => p !== "");
            return pathIds.includes(deptId);
          })
          .forEach((item) => {
            const name = item.descendant.com_name;
            if (!name || seen.has(name)) return;
            seen.add(name);
            resultList.push({ value: name, text: name });
          });
      });

      return resultList;
    },
  },
  data() {
    return {
      teamName: "",
      companyTree: [],
    };
  },
  async created() {
    this.teamName = this.initData.teamName;
    this.change(this.teamName);

    try {
      const tree = await this.$store.dispatch("company/LOAD_COMPANY_TREE", { projectId: this.projectId, all: true });
      this.companyTree = Array.isArray(tree) ? tree : [];
    } catch (e) {
      this.companyTree = [];
    }
  },
  methods: {
    change(data) {
      this.$emit("input", data);
    },
    onChange(teamName) {
      // clear 버튼 클릭 등 Event 객체가 넘어오는 경우 빈 문자열("전체") 처리
      if (typeof teamName !== "object" || teamName === null) {
        this.change(teamName);
      } else {
        this.change("");
      }
    },
  },
};
</script>
